<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Tooltip from "./Tooltip.svelte";
  import type { FormField } from "@shared/types/Form";

  export let classes: string = "fizz-full-width fizz-flow-4 fizz-stack-16 fizz-inline-block";
  export let name: string;
  export let id: string = name;
  export let field: FormField;
  export let label: string;
  export let labelClasses: string = "fizz-stack-8";
  export let onblur: (e: Event) => void = (_e: Event) => {};
  export let placeholder = "";
  export let testid: string = id;
  export let tooltip: string = "";
  export let optional: boolean = false;

  const dispatch = createEventDispatcher();

  const onBlur = (e: FocusEvent): void => {
    dispatch("blur", { target: e.currentTarget, field, fieldValue: $field });
    onblur(e);
  };

  const onChange = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("change", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onKeyUp = (e: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
    dispatch("keyUp", { target: e.currentTarget, field, fieldValue: $field });
  };

  const onFocus = (e: FocusEvent): void => {
    dispatch("click", { target: e.currentTarget, field, fieldValue: $field });
  };

</script>

<label class={classes} for={id}>
  <p class="fizz-label {labelClasses}">
    <strong>{label}</strong>
    {#if tooltip}
      <Tooltip text={tooltip} />
    {/if}
    {#if optional}
      <span class="fizz-text-subdued">(optional)</span>
    {/if}
  </p>
  <input
    {name}
    {id}
    {placeholder}
    class="fizz-input-text fizz-full-width"
    class:fizz-input-error={!$field.valid}
    data-testId={testid}
    type="text"
    bind:value={$field.value}
    on:blur={onBlur}
    on:change={onChange}
    on:focus={onFocus}
    on:keyup={onKeyUp}
  />
  <slot />
</label>
